import { inject, Injectable } from '@angular/core';
import { AuthConfigService } from '@spartacus/core';
import { AsmModeService } from 'src/app/spartacus/features/asm/asm-mode.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CustomAuthConfigService extends AuthConfigService {
  private asmModeService = inject(AsmModeService);

  /**
   * Override to dynamically return the correct client_id
   * based on ASM mode detection.
   * - asm_client → when ASM mode is enabled
   * - mobile_android_public → for standard storefront login
   */
  public override getClientId(): string {
    return this.asmModeService.isAsmMode() ? 'asm_client' : environment.clientID;
  }

  /**
   * Override to return empty secret for asm_client (PKCE flow).
   */
  public override getClientSecret(): string {
    return this.asmModeService.isAsmMode()
      ? '' // asm_client uses PKCE — no client secret
      : super.getClientSecret();
  }
}
